<template>
  <transition name="fade">
    <div
      v-if="$store.state.pageHeader.isMobileOverlayOpen"
      v-body-scroll-lock="true"
      v-bem
    >
      <div v-bem:wrapper>
        <Meta />
      </div>
      <MainMenu />
    </div>
  </transition>
</template>

<script>
import Meta from '../Meta.vue';
import MainMenu from './MainMenu.vue';

export default {
  name: 'MobileOverlay',
  components: { Meta, MainMenu },
};
</script>

<style lang="scss" scoped>
@use '~tokens/sass/utils';

@include utils.vue-transition-fade;

.mobile-overlay {
  position: fixed;
  z-index: utils.$bs-zindex-fixed;
  top: utils.f-convert-to-rem(60);
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;

  @at-root #{&}__wrapper {
    padding: utils.f-rem-calc(16);
  }
}
</style>
